export default function yupCreditCardNumberValidate(y) {
  y.addMethod(y.string, "creditCardNumber", function () {
    return this.test(
      "creditCardNumber",
      "13桁以上16桁以下で入力してください。",
      function (value) {
        const valueReplaced = value.replace(/-/g, "");
        const digit = valueReplaced.length;
        return digit >= 13 && digit <= 16;
      }
    );
  });
}
